import axios from 'axios';
import React, { Component } from 'react'
import Grid from './Grid';
import Navbar from './Navbar';

export default class Home extends Component {

    state={
        loading: true,
        memes: [],
        filter: 'All'
    }

    getMemes = () => {
        const apiUrl = process.env.REACT_APP_API_URL;
        axios({
            url: apiUrl + 'memes',
            method: 'GET',
        }).then((res, err)=>{
            if(err) throw err;
            var memes = res.data;
            if(this.state.filter != 'All') memes = memes.filter(meme=>meme.category === this.state.filter);
            this.setState({memes});
        }).catch(err=>{
            console.log("err : ", err);
        });
    }

    changeFilter = (filter) => {
        this.setState({filter});
        this.getMemes();
    }

    deletePost = (id) => {
        const apiUrl = process.env.REACT_APP_API_URL;
        axios({
          url: apiUrl + `memes/${id}`,
          method: 'DELETE',
        }).then((res, err)=>{
            console.log("record deleted");
            this.getMemes();
            if(err) throw err;
        }).catch(err=>{
            console.log("error in deleting post!");
        })
    }

    componentDidMount(){
        this.getMemes();

        this.setState({loading: false});
    }

    render() {

        return (
            <div>
                <Navbar changeFilter={this.changeFilter} />
                {this.state.loading ? <h1>Loading...</h1> : <Grid getMemes={this.getMemes} deletePost={this.deletePost} memes={this.state.memes}/>}
            </div>
        )
    }
}
